/**
 * @generated SignedSource<<246de047b3c4c1c596dfa6238b020244>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightDetailsPrice_flight$data = {
  readonly isUpdating: boolean;
  readonly lastSuccessfulUpdate: {
    readonly createdAt: string;
  } | null;
  readonly priceLive: number;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListProvider_flight">;
  readonly " $fragmentType": "FlightDetailsPrice_flight";
};
export type FlightDetailsPrice_flight$key = {
  readonly " $data"?: FlightDetailsPrice_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightDetailsPrice_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightDetailsPrice_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceLive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUpdating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightPrice",
      "kind": "LinkedField",
      "name": "lastSuccessfulUpdate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightListProvider_flight"
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "51c6b52e0e5629362eefcdced91e40c9";

export default node;
